import React from 'react';

function Circle(){
    return(
        <svg version="1.1" id="circle" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 50 50">
            <circle className="st0" cx="25.1" cy="24.6" r="22.8"/>
        </svg>
    )
}

export default Circle;